import Skeleton from '../skeleton/Skeleton';
import {
  StyledAnalytics,
  StyledChannelCard,
  StyledFunnelBar,
  StyledGrid12,
  StyledKpiCard,
  StyledKpiGrid,
  StyledPageHeader,
  StyledSectionTitle,
  StyledSurface,
  StyledTopList,
} from './Analytics.styles';

const ChannelCardSkeleton = () => (
  <StyledChannelCard $color="var(--hd-border)">
    <div className="channel-head">
      <Skeleton width={28} height={28} radius="10px" resp />
      <Skeleton width={72} height={14} radius="6px" resp />
    </div>
    <div className="stats">
      {[0, 1, 2, 3].map(key => (
        <div key={key}>
          <Skeleton width={56} height={11} radius="6px" resp />
          <Skeleton width={48} height={20} radius="6px" margin="6px 0 0" resp />
        </div>
      ))}
    </div>
  </StyledChannelCard>
);

/** The whole page's shape, shown until the graphs and the campaigns list have all arrived. */
const AnalyticsSkeleton = () => (
  <StyledAnalytics aria-busy="true">
    <main className="analytics-main">
      <section>
        <StyledPageHeader>
          <div>
            <Skeleton width={140} height={28} radius="8px" resp />
            <Skeleton width={360} height={14} radius="6px" margin="10px 0 0" resp />
          </div>
          <div className="header-actions">
            <Skeleton width={300} height={36} radius="18px" resp />
            <Skeleton width={96} height={36} radius="14px" resp />
          </div>
        </StyledPageHeader>
        <StyledKpiGrid>
          {[0, 1, 2, 3].map(key => (
            <StyledKpiCard key={key} $up>
              <div className="kpi-head">
                <Skeleton width={110} height={12} radius="6px" resp />
                <Skeleton width={32} height={32} radius="14px" resp />
              </div>
              <div className="kpi-value">
                <Skeleton width={96} height={28} radius="8px" resp />
              </div>
              <Skeleton width={140} height={12} radius="6px" margin="8px 0 0" resp />
            </StyledKpiCard>
          ))}
        </StyledKpiGrid>
      </section>

      <StyledGrid12>
        <StyledSurface className="span-8">
          <div className="card-head">
            <div>
              <Skeleton width={140} height={16} radius="6px" resp />
              <Skeleton width={220} height={12} radius="6px" margin="8px 0 0" resp />
            </div>
            <Skeleton width={180} height={12} radius="6px" resp />
          </div>
          <Skeleton width="100%" height={224} radius="14px" resp />
        </StyledSurface>
        <StyledSurface className="span-4">
          <Skeleton width={80} height={16} radius="6px" resp />
          <Skeleton width={180} height={12} radius="6px" margin="8px 0 20px" resp />
          {[0, 1, 2, 3, 4].map(key => (
            <StyledFunnelBar key={key}>
              <div className="funnel-row">
                <Skeleton width={80} height={12} radius="6px" resp />
                <Skeleton width={64} height={12} radius="6px" resp />
              </div>
              <Skeleton width="100%" height={8} radius="999px" resp />
            </StyledFunnelBar>
          ))}
        </StyledSurface>
      </StyledGrid12>

      <StyledGrid12>
        <div className="stack span-7">
          <StyledSectionTitle>
            <Skeleton width={160} height={16} radius="6px" resp />
          </StyledSectionTitle>
          <ChannelCardSkeleton />
          <ChannelCardSkeleton />
        </div>
        <div className="stack span-5">
          <StyledSectionTitle>
            <Skeleton width={200} height={16} radius="6px" resp />
          </StyledSectionTitle>
          <StyledTopList>
            {[0, 1, 2].map(key => (
              <div key={key} className="top-row">
                <Skeleton width={36} height={36} radius="14px" resp />
                <div className="top-main">
                  <Skeleton width="60%" height={14} radius="6px" resp />
                  <Skeleton width="40%" height={12} radius="6px" margin="6px 0 0" resp />
                </div>
                <Skeleton width={40} height={28} radius="8px" resp />
              </div>
            ))}
          </StyledTopList>
        </div>
      </StyledGrid12>
    </main>
  </StyledAnalytics>
);

export default AnalyticsSkeleton;
